import { jsx as _jsx } from "react/jsx-runtime";
import { ConfirmationModal } from '@streem/ui-react';
export const DeclineCallConfirmation = ({ isOpen, onCancel, handleDeclineCall, }) => {
    return (_jsx(ConfirmationModal, { testID: "decline-confirmation", isOpen: isOpen, onCancel: onCancel, onConfirm: handleDeclineCall, closeOnOverlayClick: false, closeOnEscape: false, hideCloseButton: true, closeDelayMS: 300, inCall: true, styleOverride: {
            content: {
                width: '37.5rem',
            },
        }, headerText: "Are you sure?", bodyText: "Are you sure you want to decline this video chat?", primaryButtonText: "Decline Video Chat", primaryButtonVariant: "danger" }));
};
//# sourceMappingURL=decline_call_confirmation.js.map